export function isAddressSearchType() {
  const searchType = window.mapSupport && window.mapSupport.searchType;
  return searchType === 'address_search_simple' ||
    searchType === 'address_search_advanced' ||
    searchType === 'address_search_multiple';
}
